var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m9.725 18.725-1.45-1.45L10.525 15l-2.25-2.275 1.45-1.45L12 13.525l2.275-2.25 1.45 1.45L13.475 15l2.25 2.275-1.45 1.45L12 16.475ZM5.075 22.2q-.95 0-1.612-.662-.663-.663-.663-1.613V6.075q0-.95.663-1.613.662-.662 1.612-.662H6v-2h2.15v2h7.7v-2H18v2h.925q.95 0 1.613.662.662.663.662 1.613v13.85q0 .95-.662 1.613-.663.662-1.613.662Zm0-2.275h13.85V10H5.075v9.925ZM5.075 8h13.85V6.075H5.075Zm0 0V6.075 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.1dca3e438363e8924df56b605ca9b1b0.svg";
export { ForwardRef as ReactComponent };